module.exports = require('./url-info');



// WEBPACK FOOTER //
// ./src/olycommon/urlinfo/index.js